export const EVENT_SALES_STATUS_EXPANSION = 'event_sales_status';
export const BASIC_INVENTORY_INFO_EXPANSION = 'basic_inventory_info';
export const DISCOUNT_USAGE_COUNTS_EXPANSION = 'discount_usage_counts';
